<script setup lang="ts">
import { defineProps } from "vue";

const props = defineProps<{ post: Post }>();

computed(() => {
  return props.post.audio;
});
</script>

<template>
  <NuxtLink :to="`/blog/${props.post.slug}`" class="post-grid masonry-item">
    <article class="grid-blog-post">
      <slot v-if="props.post.images" default>
        <div v-if="props.post.images[0]?.formats.thumbnail?.url" class="post-thumbnail" style="max-height: 200px; object-fit: fill">
          <img :src="composeImageUrl(props.post.images[0]?.formats.thumbnail?.url)" :alt="props.post.title" />
        </div>
      </slot>

      <div v-else class="embed-responsive embed-responsive-16by9">
        <slot name="media" />
      </div>

      <div class="post-content">
        <div class="post-content-inner">
          <h3 :style="[!props.post?.images != null ? { 'margin-top': '0' } : {}]">
            <span class="post-title">{{ props.post.title }}</span>
          </h3>
          <ul class="meta-info">
            <!-- <li>
              <span>{{ props.post.slug }}</span>
            </li> -->
            <li>
              <span>{{ new Date(props.post.createdAt).toLocaleDateString() }}</span>
            </li>
            <li>
              <span>{{ props.post.categoria?.title }}</span>
            </li>
          </ul>
          <!-- <p>{{ props.excerpt }}</p> -->
        </div>
        <div class="post-footer-meta clearfix">
          <!-- <ul class="post-action-btn">
            <li>
              <a href="#"><i class="icon-refresh"></i></a>
            </li>
            <li>
              <a href="#"><i class="icon-chat"></i></a>
            </li>
            <li>
              <a href="#"><i class="icon-heart"></i></a>
            </li>
          </ul> -->
          <div class="read-more-wrapper">
            <NuxtLink :to="`/blog/${props.post.slug}`" class="button">read more<i class="ti-arrow-right"></i></NuxtLink>
            <!-- <a href="#" class="like-count"><i class="ti-heart"></i><span>62</span></a> -->
          </div>
        </div>
      </div>
    </article>
  </NuxtLink>
</template>
<style scoped>
.masonry-item {
  background-color: var(--background-color);
  color: var(--title-color);
}
.post-thumbnail img {
  width: 100%;
  object-fit: cover;
  height: 100%;
  aspect-ratio: 16 / 9;
}
.post-title {
  color: var(--primary-color);
  min-height: 60px;
  max-height: 60px;
  height: 60px;
  display: block;
  text-overflow: ellipsis;
  overflow: hidden;
}

.read-more-wrapper a {
  color: var(--title-color);
}
.meta-info li span {
  color: var(--subtitle-color);
}
</style>
